import axios from 'axios'
import qs from 'qs'
import moment from 'moment'
import config from '../config'
import { processDataIuran, composeIuran } from '../lib/iuran'
import hitungIuran from './hitung-iuran'
import prosesKodeIuran from './proses-kode-iuran'
import {request} from './authorized-request'

const register = peserta =>
  new Promise(async (resolve, reject) => {
    const {
      NIK, Gaji, JHT, PeriodeProgram,
      NoPonsel, NamaLengkap, TglLahir, BlnLahir, ThnLahir, 
      Alamat, Cabang, Pekerjaan, 
      Kota, JamMasukKantor, JamKeluarKantor, Email,
    } = peserta
    const bd = moment(`${TglLahir}-${BlnLahir}-${ThnLahir}`, 'DD-MM-YYYY').format('DD-MM-YYYY')

    const dataRegister = qs.stringify({
      nik: NIK,
      noHp: NoPonsel, 
      namaKtp: NamaLengkap, 
      tglLahir: bd,
      email: Email,
      alamat: Alamat, 
      kodeKantor: Cabang,
      jenisPekerjaan: Pekerjaan, 
      lokasiPekerjaan: Kota, 
      jamAwal: JamMasukKantor, 
      jamAkhir: JamKeluarKantor,
      upah: Gaji,
    })

    try {
      const result = await request('daftarpeserta', 'post', dataRegister)
      resolve({
        status: 'success',
        msg: 'Pendaftaran anda berhasil'
      })
    } catch (error) {
      reject({
        status: 'error',
        msg: error.msg
      })
    }
  })

export default register

/**
 * Sekarang yang harusnya gw lakuakn adalah mencoba handle errornya, statenya gw pisha jadi beberapa step, error form per state dan gw kasigh template buat messagenya
 * I think its easy to accomplish, damn too easy.
 * 
 */


// WEBPACK FOOTER //
// ./src/bpjs-api/register.js